/**
 *
 * Styles for BillingCountryCard
 *
 */

import styled, { css } from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { Flag, Card } from "root/libs/ui-components/src";
import { DhlButton } from "@dhl-official/react-library";

export const DisabledCountryCard = styled(Card)`
  border: solid var(--dui-size-width-border-xs) transparent;
  display: block;
  padding: calc(var(--dui-size-space-7x) + 0.5rem) var(--dui-size-space-7x)
    var(--dui-size-space-7x);
  position: relative;
  transition: box-shadow var(--dui-duration-default),
    border-color var(--dui-duration-default);
  user-select: none;

  &:focus-within,
  &:hover {
    box-shadow: var(--dui-size-space-0) var(--dui-size-space-1x)
      var(--gaq-size-space-7px) var(--dui-size-space-1)
      var(--dui-color-gray-500);
  }
`;

export const CountryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const CountryFlag = styled(Flag)`
  // Defines the scale of flag sprites
  --s: 0.5;
  display: inline-block;
  @media screen and (min-width: ${breakpoints.tablet}) {
    --s: 0.75;
  }
`;
export const CountryLabel = styled.p.attrs((props) => ({
  "aria-labelledby": props.ariaLabelledby,
  "data-testid": props.dataTestid,
  "data-countryid": props.dataCountryId,
  tabIndex: props.tabIndex,
}))`
  display: inline-block;
  margin: 0;
  padding: 0 0 0 var(--dui-size-space-7x);
  flex: 1;
`;

export const BillingCountryNote = styled.p`
  flex: 1 0 100%;
  border-top: var(--dui-size-width-border-xs) solid var(--dui-color-gray-300);
  margin: var(--dui-size-space-7x) 0 0 0;
  padding: calc(var(--dui-size-space-7x) / 2) 0 0 0;
  font-size: var(--dui-size-font-xs);
`;

export const ChangeCountryButton = styled(DhlButton)`
  padding: 0;

  span {
    font-size: var(--dui-size-font-md);
    font-weight: normal;
    text-decoration: underline;
    white-space: nowrap;

    ${({ hasPostcodesEnabled }) =>
      hasPostcodesEnabled
        ? css`
            align-items: center;
            display: flex;
            flex-flow: row wrap;
            font-size: var(--dui-size-font-sm);
            gap: var(--dui-size-space-2x);
          `
        : undefined}
  }
`;
